{
  "LABEL_MGMT": {
    "HEADER": "Etykiety",
    "HEADER_BTN_TXT": "Dodaj etykietę",
    "LOADING": "Pobieranie etykiet",
    "DESCRIPTION": "Labels help you categorize and prioritize conversations and leads. You can assign a label to a conversation or contact using the side panel.",
    "LEARN_MORE": "Learn more about labels",
    "COUNT": "{n} label | {n} labels",
    "SEARCH_PLACEHOLDER": "Szukaj etykiet...",
    "NO_RESULTS": "No labels found matching your search",
    "SEARCH_404": "Brak elementów pasujących do tego zapytania",
    "LIST": {
      "404": "Brak etykiet na tym koncie.",
      "TITLE": "Zarządzaj etykietami",
      "DESC": "Etykiety pozwalają na grupowanie rozmów razem.",
      "TABLE_HEADER": {
        "NAME": "Imię",
        "DESCRIPTION": "Opis",
        "COLOR": "Kolor",
        "ACTION": "Akcje"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nazwa etykiety",
        "PLACEHOLDER": "Nazwa etykiety",
        "REQUIRED_ERROR": "Nazwa etykiety jest wymagana",
        "MINIMUM_LENGTH_ERROR": "Wymagana długość wynosi minimum 2",
        "VALID_ERROR": "Dozwolone są tylko litery, cyfry, myślnik i podkreślenie"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Opis etykiety"
      },
      "COLOR": {
        "LABEL": "Kolor"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Pokaż etykietę na panelu bocznym"
      },
      "EDIT": "Edytuj",
      "CREATE": "Stwórz",
      "DELETE": "Usuń",
      "CANCEL": "Anuluj"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Add label to conversation",
        "MULTIPLE_SUGGESTION": "Select this label",
        "DESELECT": "Deselect label",
        "DISMISS": "Dismiss suggestion"
      },
      "POWERED_BY": "Chatwoot AI",
      "DISMISS": "Odrzuć",
      "ADD_SELECTED_LABELS": "Add selected labels",
      "ADD_SELECTED_LABEL": "Add selected label",
      "ADD_ALL_LABELS": "Add all labels",
      "SUGGESTED_LABELS": "Suggested labels"
    },
    "ADD": {
      "TITLE": "Dodaj etykietę",
      "DESC": "Etykiety pozwalają na grupowanie rozmów razem.",
      "API": {
        "SUCCESS_MESSAGE": "Etykieta dodana pomyślnie",
        "ERROR_MESSAGE": "Wystąpił błąd, spróbuj ponownie"
      }
    },
    "EDIT": {
      "TITLE": "Edytuj etykietę",
      "API": {
        "SUCCESS_MESSAGE": "Etykieta została pomyślnie zaktualizowana",
        "ERROR_MESSAGE": "Wystąpił błąd, spróbuj ponownie"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "API": {
        "SUCCESS_MESSAGE": "Etykieta została usunięta",
        "ERROR_MESSAGE": "Wystąpił błąd, spróbuj ponownie"
      },
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Czy na pewno chcesz usunąć ",
        "YES": "Tak, usuń ",
        "NO": "Nie, zachowaj "
      }
    }
  }
}
